export enum JourneyStepType {
    Do = 'Do',
    Read = 'Read'
}
